import { apiClient } from "@wtf/shared/api/utils/api-client";

export interface ExchangeRates {
  base: string;
  rates: Record<string, number>;
  timestamp: string;
}

const BASE_ENDPOINT = "api/currency";

/**
 * Get current exchange rates
 */
export async function getCurrencyRates(): Promise<ExchangeRates> {
  return apiClient<ExchangeRates>(`${BASE_ENDPOINT}/rates`);
}

export const currencyApi = {
  getCurrencyRates,
};
